import { render, staticRenderFns } from "./AppSettingsPanel.vue?vue&type=template&id=ac23d134&scoped=true&"
import script from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsPanel.vue?vue&type=style&index=0&id=ac23d134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac23d134",
  null
  
)

export default component.exports